module.exports = __webpack_public_path__ + "img/77400.2a27b99a.svg";